module.exports = __webpack_public_path__ + "static/media/order-failure.960190e2.svg";